/**
 * Created by Jerker Nord on 2018-11-27.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TimelineLite} from "gsap";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ThorParsedInitData} from "../../server/data/ThorParsedInitData";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {IconState} from "../../featureIcons/IIconView";
import {ThorRandomWildsWPController} from "../../winpresentation/randomwilds/ThorRandomWildsWPController";

export class ThorRandomWildsController extends ReelStopPresentationController {

    private _overlayWilds:boolean[][];
    private _addNewWilds:boolean = false;
    private _isNudgeRespin:boolean = false;
    private _currentMode:string;
    private _nextMode:string;
    private _FSBonusFeatureSelectStarted:boolean = false;
    private _playHammertime:boolean = false;
    private _nudgeFeatureRewarded:string;
    private _disableRandomWildIcon:boolean = false;
    private _restoreWilds:boolean[][];
    private _singleWin:number;
    private _addNewWildsTL:TimelineLite;
    private _doRestore:boolean;

    constructor(index:number) {
        super(index, "ThorRandomWildsController");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
    }

    public abort():void {
        if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
            this._addNewWildsTL.pause();
            this._addNewWildsTL.kill();
        }
    }

    private onInitDataParsed(data:ThorParsedInitData):void {
        this._restoreWilds = data.overlayWilds!;
        this._doRestore = false;
        if(data.isRandomWild == true) {
            if((data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN)
                || (data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN)
                || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)
                || (data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {
                this._doRestore = true;
            }
        }
    }

    private onRestore():void {
        if(this._doRestore == true) {
            ThorGameModuleConfig.thorRandomWildIconView.setState(IconState.activated);
        }
    }

    /**
     * Activates wild overlays. Restores orignal sym under wild
     */
    private onBeforeSpinStart():void {
        if((this._currentMode == ThorGameMode.NORMAL && this._nextMode == ThorGameMode.NUDGE_RESPIN)
            || (this._currentMode == ThorGameMode.NUDGE_RESPIN && this._nextMode == ThorGameMode.NUDGE_RESPIN)
            || (this._currentMode == ThorGameMode.FREESPIN && this._nextMode == ThorGameMode.NUDGE_RESPIN_FS)
            || (this._currentMode == ThorGameMode.NUDGE_RESPIN_FS && this._nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {
            ThorGameModuleConfig.thorRandomWildsView.showAllWilds();
        }
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._singleWin = data.singleWin;
        this._isNudgeRespin = false;
        this._currentMode = data.mode;
        this._nextMode = data.nextMode;
        this._nudgeFeatureRewarded = data.nudgeFeatureRewarded;
        if(((data.mode == ThorGameMode.NUDGE_RESPIN
            || data.nextMode == ThorGameMode.NUDGE_RESPIN) && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_WILDS)
            || data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NORMAL
            || ((data.mode == ThorGameMode.NUDGE_RESPIN_FS || data.nextMode == ThorGameMode.NUDGE_RESPIN_FS) && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_WILDS)
        ) {
            this._overlayWilds = this.getNewWilds(data.overlayWildsBeforeSpinStop, data.overlayWildsAfterSpinStop);
            this._addNewWilds = this.hasNewWilds(this._overlayWilds);
            this._isNudgeRespin = true;
            if((data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS) || (data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN)) {
                this._playHammertime = true;
            }
        }
        if((this._isNudgeRespin && (data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NORMAL))
            || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.FREESPIN)) {
            this._disableRandomWildIcon = true;
        }
    }

    private getNewWilds(wildsBefore:boolean[][], wildsAfter:boolean[][]):boolean[][] {
        let newWilds:boolean[][] = [[false, false, false], [false, false, false], [false, false, false], [false, false, false], [false, false, false]];

        for(let i:number = 0; i < wildsAfter.length; i++) {
            for(let j:number = 0; j < wildsAfter[i].length; j++) {
                if(wildsAfter[i][j] == true && wildsBefore[i][j] == false) {
                    newWilds[i][j] = true;
                } else {
                    newWilds[i][j] = false;
                }
            }
        }
        return newWilds;
    }

    private hasNewWilds(overlayWilds:boolean[][]):boolean {
        if(this._nextMode == ThorGameMode.NORMAL) {
            return false;
        }
        for(let i:number = 0; i < overlayWilds.length; i++) {
            for(let j:number = 0; j < overlayWilds[i].length; j++) {
                if(overlayWilds[i][j] == true) {
                    return true;
                }
            }
        }

        return false;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId == 3 && this._disableRandomWildIcon) {
            if(this._singleWin > 0) {
                ThorGameModuleConfig.thorRandomWildIconView.disableRandomWildIconTL(1);
            } else {
                ThorGameModuleConfig.thorRandomWildIconView.disableRandomWildIconTL(0);
            }
            this._disableRandomWildIcon = false
        }
        if(this._addNewWilds == true && (data.reelId == 4 && ((this._currentMode == ThorGameMode.NORMAL && this._nextMode == ThorGameMode.NUDGE_RESPIN)
            || (this._currentMode == ThorGameMode.FREESPIN && this._nextMode == ThorGameMode.NUDGE_RESPIN_FS) || this._nextMode == ThorGameMode.NUDGE_RESPIN_FS))) {
            this._addNewWilds = false;
            if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
                this._addNewWildsTL.pause();
                this._addNewWildsTL.kill();
            }
            this._addNewWildsTL = new TimelineLite({});
            if(this._playHammertime == true) {
                this._playHammertime = false;
                ThorGameModuleConfig.thorMjolnirtimeView.getMjolnirtimeAnimation().play();
                this._addNewWildsTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRandomWildsWPController.ICON_SELECT_ANIMATION_STARTED)));
                this._addNewWildsTL.add(ThorGameModuleConfig.thorRandomWildIconView.enableRandomWildIconSelectTL((this._currentMode == ThorGameMode.NUDGE_RESPIN_FS || this._currentMode == ThorGameMode.FREESPIN)));
                this._addNewWildsTL.add(() => EventHandler.dispatchEvent(new GameEvent(ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE)));
            }
        }
        this.dispatchCompleteEvent(data.reelId);
    }
}